export const PMS_ROW_SUPPORTING_FILE_COUNT_CHANNEL =
   'tyalls-pms-row-supporting-file-counts';

export interface PmsRowSupportingFileCountChangedMessage {
   type: 'PMS_ROW_SUPPORTING_FILE_COUNT_CHANGED';
   taskInstanceId: number;
   pmsDataId: number;
   targetRowId: string;
   fileCount: number;
}

export function isPmsRowSupportingFileCountChangedMessage(
   value: unknown
): value is PmsRowSupportingFileCountChangedMessage {
   if (!value || typeof value !== 'object') {
      return false;
   }

   const message = value as Partial<PmsRowSupportingFileCountChangedMessage>;

   return (
      message.type === 'PMS_ROW_SUPPORTING_FILE_COUNT_CHANGED' &&
      Number.isInteger(message.taskInstanceId) &&
      Number(message.taskInstanceId) > 0 &&
      Number.isInteger(message.pmsDataId) &&
      Number(message.pmsDataId) > 0 &&
      typeof message.targetRowId === 'string' &&
      message.targetRowId.trim().length > 0 &&
      Number.isInteger(message.fileCount) &&
      Number(message.fileCount) >= 0
   );
}
